export const P0003605DureeQuotidienneInjection = [
  { label: '1 min 00', ref: 1 },
  { label: '2 min 00', ref: 2 },
  { label: '3 min 00', ref: 3 },
  { label: '4 min 00', ref: 4 },
  { label: '5 min 00', ref: 5 },
  { label: '6 min 00', ref: 6 },
  { label: '7 min 00', ref: 7 },
  { label: '8 min 00', ref: 8 },
];
